// extracted by mini-css-extract-plugin
module.exports = {"root":"Board_root__3r68U"};